import { keycloakEnv } from '@/api/constants';
import Keycloak from 'keycloak-js';

export async function initializeKeycloak() {
  const keycloak = new Keycloak({
    url: keycloakEnv.url,
    realm: keycloakEnv.realm,
    clientId: keycloakEnv.clientId,
  });

  try {
    const authenticated = await keycloak.init({
      onLoad: 'login-required',
      checkLoginIframe: false,
      pkceMethod: 'S256',
    });

    if (authenticated) {
      console.log('User is authenticated');
    } else {
      console.log('User is not authenticated');
    }
  } catch (error) {
    console.error('Failed to initialize adapter:', error);
  }
  return keycloak;
}
